<template>
  <div
    class="row bg-origami pb-xl"
    data-test="curated-collections">
    <HomepageSection title="Our Top Curated Collections"/>
    <template v-if="featuredCollections.length > 0">
      <MyClosetSectionPreview
        v-for="collection in featuredCollections"
        :key="collection.id"
        :section-id="collection.id"
        prospect
        class="col-12 pb-xl"/>
    </template>
    <template v-else>
      <MyClosetSectionPreviewPlaceholder
        v-for="index in 3"
        :key="index"
        :description-lines="1"
        class="col-12 pb-xl"/>
    </template>
  </div>
</template>
<script setup>
import { computed, provide } from 'vue'
import MyClosetSectionPreview from '@/components/closet/MyClosetSectionPreview.vue'
import { useClosetStore } from '@shared/stores/closet.js'
import { getSectionHref } from '@shared/utils/route.js'
import { storeToRefs } from 'pinia'
import HomepageSection from '@/homepage/components/HomepageSection.vue'
import MyClosetSectionPreviewPlaceholder from '@/components/closet/placeholder/MyClosetSectionPreviewPlaceholder.vue'

const closetStore = useClosetStore()
const { homepageSections } = storeToRefs(closetStore)

const collections = computed(() => homepageSections.value?.map(section => {
  return {
    id: section.id,
    title: section.name,
    imageUrl: section.bannerImageUrl,
    routeLocation: getSectionHref(section)
  }
}) ?? [])
const featuredCollections = computed(() => collections.value.slice(0, 3))

provide('useClosetDetailFlyout', false)
</script>

<style lang="scss" scoped>
:deep(.description) {
  a {
    text-decoration: none !important;
  }
}
</style>
